import React, { useEffect } from "react";
import { useIntl } from "react-intl";

import { DataGrid } from "devextreme-react";
import { Scrolling, Column } from "devextreme-react/data-grid";

import GoAiguaCheckbox from "components/generic/goaiguacheckbox";

import { GisLayerTableType } from "types/generic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

type GisLayerTableParams = {
    rowSelected: GisLayerTableType[];
    setRowSelected: (rowSelected: GisLayerTableType[]) => void;
    rowSelectedWithId: GisLayerTableType[];
    setRowSelectedWithId: (rowSelectedWithId: GisLayerTableType[]) => void;
    rowData: GisLayerTableType[];
    setLayerId: React.Dispatch<React.SetStateAction<number>>;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const GisLayerTable = ({
    rowSelected,
    setRowSelected,
    rowSelectedWithId,
    setRowSelectedWithId,
    rowData,
    setLayerId,
    setIsOpen,
}: GisLayerTableParams) => {
    const intl = useIntl();
    const sortData: any = rowData;

    useEffect(() => {
        sortData.sort((a: any, b: any) => {
            if (a.id > b.id) {
                return 1;
            } else if (a.id < b.id) {
                return -1;
            } else {
                return 0;
            }
        });
    }, [rowData]);

    return (
        <DataGrid
            dataSource={sortData}
            allowColumnReordering={false}
            showBorders={false}
            rowAlternationEnabled={true}
            showColumnLines={false}
            showRowLines={false}
            columnAutoWidth={false}
            onCellClick={(e: any) => e.component.refresh()}
            noDataText={""}
            height={"100%"}
            paging={{ enabled: false }}
        >
            <Scrolling mode="standart" />
            <Column
                dataField="id"
                caption="ID"
                dataType="string"
                cellRender={(params) => (
                    <div className={"c-layer-table__check-box-container"}>
                        <div className={"c-layer-table__check-box-element"}>
                            <GoAiguaCheckbox
                                checkedStatus={
                                    rowSelectedWithId.find(
                                        (layer) => layer.id === params.data.id
                                    )
                                        ? "checked"
                                        : "not-checked"
                                }
                                setCheckedStatus={() => {
                                    if (rowSelectedWithId.length === 0) {
                                        const { id, ...rowSelectedNoId } =
                                            params.data;
                                        setRowSelectedWithId([params.data]);
                                        setRowSelected([rowSelectedNoId]);
                                    } else {
                                        const rowIndex =
                                            rowSelectedWithId.findIndex(
                                                (e) => e === params.data
                                            );
                                        if (rowIndex !== -1) {
                                            setRowSelectedWithId([]);
                                            setRowSelected([]);
                                        } else {
                                            const { id, ...rowSelectedNoId } =
                                                params.data;
                                            setRowSelectedWithId([params.data]);
                                            setRowSelected([rowSelectedNoId]);
                                        }
                                    }
                                }}
                            />
                        </div>
                        {params.value}
                    </div>
                )}
            />
            <Column
                dataField="layerName"
                caption={intl.formatMessage({
                    id: "app.gis.layer_name",
                })}
                dataType="string"
            />
            <Column
                dataField="layerType"
                caption={intl.formatMessage({
                    id: "app.gis.layer_type",
                })}
                dataType="string"
            />

            <Column
                type="buttons"
                caption={intl.formatMessage({ id: "app.gis.actions" })}
                cellRender={(params: any) => {
                    return (
                        <FontAwesomeIcon
                            className={"c-button-delete"}
                            icon={faTrashAlt}
                            onClick={() => {
                                setIsOpen(true);
                                setLayerId(params.data.id);
                            }}
                        />
                    );
                }}
            ></Column>
        </DataGrid>
    );
};

export default GisLayerTable;
